export const fillContainer = {
  backgroundColor: '#fff'
};

export const buttonAlignment = {
  width: '100%',
  margin: 0,
  marginTop: '1em'
};

export const disabledButton = {
  width: '100%',
  margin: 0,
  marginTop: '1em',
  color: '#999',
  border: '1px solid #999',
  backgroundColor: '#F2F2F2'
};

export const popupCard = {
  minWidth: '360px',
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  height: '100%',
  padding: '1em'
};
